import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { Button } from '@pepper/ui'

import AppliedFilterPill from 'components/idea-lab/AppliedFilterPill'

type Props = {
  formatTopicsAndKeywordsCount: (value: string) => void
}

export const ListFilter = ({ formatTopicsAndKeywordsCount }: Props) => {
  const [queryParams, setQueryParams] = useQueryParams({
    keyword: withDefault(StringParam, undefined),
    topic: withDefault(StringParam, undefined),
    theme_id: withDefault(StringParam, undefined),
    positionLte: withDefault(NumberParam, undefined),
    positionGte: withDefault(NumberParam, undefined),
    exclude_position: withDefault(BooleanParam, false),
    crr_id: withDefault(BooleanParam, undefined),
    item_id: withDefault(BooleanParam, undefined),
  })

  return (
    <>
      {queryParams.topic && (
        <AppliedFilterPill
          label={`Topic Contains: ${formatTopicsAndKeywordsCount(
            queryParams.topic
          )}`}
          onClear={() =>
            setQueryParams({
              topic: undefined,
            })
          }
        />
      )}
      {queryParams.keyword && (
        <AppliedFilterPill
          label={`Inc. Keywords: ${formatTopicsAndKeywordsCount(
            queryParams.keyword
          )}`}
          onClear={() =>
            setQueryParams({
              keyword: undefined,
            })
          }
        />
      )}
      {queryParams?.positionLte && queryParams.positionGte && (
        <AppliedFilterPill
          label={`Pos: ${queryParams.positionGte} - ${queryParams.positionLte}`}
          onClear={() =>
            setQueryParams({
              positionGte: undefined,
              positionLte: undefined,
              exclude_position: undefined,
            })
          }
        />
      )}
      {queryParams.exclude_position &&
        !queryParams?.positionLte &&
        !queryParams.positionGte && (
          <AppliedFilterPill
            label="Exclude positions"
            onClear={() =>
              setQueryParams({
                exclude_position: undefined,
              })
            }
          />
        )}
      {queryParams.crr_id !== undefined && (
        <AppliedFilterPill
          label={`SEO: ${queryParams.crr_id ? 'Show' : 'Hide'}`}
          onClear={() =>
            setQueryParams({
              crr_id: undefined,
            })
          }
        />
      )}
      {queryParams.item_id !== undefined && (
        <AppliedFilterPill
          label={`Items: ${queryParams.item_id ? 'Show' : 'Hide'}`}
          onClear={() =>
            setQueryParams({
              item_id: undefined,
            })
          }
        />
      )}
      <Button
        type="link"
        onClick={() =>
          setQueryParams({
            keyword: undefined,
            topic: undefined,
            crr_id: undefined,
            item_id: undefined,
            exclude_position: undefined,
            positionGte: undefined,
            positionLte: undefined,
          })
        }
      >
        Clear Filter
      </Button>
    </>
  )
}
